/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Партнёр
 */
export type OrderCreatePartner = {
  /**
   * Тип партнёра
   */
  type?: OrderCreatePartner.type
  /**
   * Пользователь сам, как физ.лицо или представитель заказчика юр.лица
   */
  isUser: boolean
  /**
   * Идентификатор контакта (обязательно при isUser=false)
   */
  contactId?: string
  /**
   * Идентификатор контрагента (обязательно при isUser=false и type=Legal)
   */
  companyId?: string
}
export namespace OrderCreatePartner {
  /**
   * Тип партнёра
   */
  export enum type {
    LEGAL = 'legal',
    INDIVIDUAL = 'individual'
  }
}
